import { isGpcActive } from '#pplx/frontend/analytics/browser/gpc.js';
import { PPLX_TRACKING_ALLOWED } from '#pplx/frontend/analytics/core.js';
import { getCookie, setCookie } from '#pplx/frontend/cookies/provider.js';
import { logger } from '#pplx/frontend/logger/browser.js';
export const readConsentCookie = () => {
    const consentCookie = getCookie(PPLX_TRACKING_ALLOWED);
    return consentCookie === 'true' || consentCookie === 'false' ? consentCookie : undefined;
};
export const consentCookieFromChange = (event) => event.detail.consent === 'ALLOW' ? 'true' : 'false';
export const readGpcOptOut = () => {
    try {
        return isGpcActive();
    }
    catch {
        logger.warn('Failed to read Global Privacy Control; blocking tracking');
        return true;
    }
};
// Shared by the cookie banner and explicitly disclosed broad-consent actions.
export const allowAllTracking = () => {
    setCookie(PPLX_TRACKING_ALLOWED, 'true', { expires: 365 });
    window.dispatchEvent(new CustomEvent('consentChange', { detail: { consent: 'ALLOW' } }));
};
export const hasTrackingConsent = (trackingPolicy, consentCookie) => trackingPolicy === 'nonblocking' ? consentCookie !== 'false' : consentCookie === 'true';
//# sourceMappingURL=consentPolicy.js.map